import axios from 'axios';
import {flashMessage} from 'redux-flash';
import _ from 'lodash';
import Config from '../../config';

export function single(id, languages) {
    return (dispatch) => axios.get(`${Config.api.endpoint}api/Menu/${id}`, Config.getApiConfig())
        .then((response) => {
            if (response) {
                const menuData = {};

                languages.forEach((language) => {
                    const find = _.find(response.data.menuData, (item) => item.language.code === language.code);

                    if (find) {
                        menuData[language.code] = find;
                    } else {
                        menuData[language.code] = {
                            data: {},
                            language,
                        };
                    }
                });

                dispatch({
                    type: 'MENU_SINGLE_SUCCESS',
                    payload: {
                        data: {
                            ...response.data,
                        },
                    },
                });

                dispatch({
                    type: '@@redux-form/INITIALIZE',
                    meta: {
                        form: 'MenuForm',
                        keepDirty: undefined,
                    },
                    payload: {
                        ...response.data,
                        menuData,
                    },
                });

                return response;
            }
        });
}

export function get(parentWorkspaceId, language, backOffice = false) {
    return (dispatch) => {
        dispatch({
            type: 'MENU_START_GET',
            payload: {
                type: 'menus',
            },
        });

        const queryParams = {
            backOffice: backOffice
        };

        const queryParamsString = new URLSearchParams(queryParams).toString();

        return axios.get(`${Config.api.endpoint}api/Menu/structure/${parentWorkspaceId}/${language}?${queryParamsString}`, Config.getApiConfig())
            .then((response) => {
                if (response) {
                    dispatch({
                        type: 'MENU_GET_SUCCESS',
                        payload: {
                            type: 'menus',
                            data: response.data,
                        },
                    });

                    dispatch({
                        type: 'MENU_REFRESH_FALSE',
                    });

                    return response;
                }
            });
    };
}

export function post(values, workspace) {
    const {parentWorkspaceId, title, ...newValues} = values;

    const params = {
        ...newValues,
        sortIndex: 0,
        parentNodeId: values.parentNodeId || null,
        parentWorkspaceId: !values.parentNodeId ? workspace : null,
    };

    return (dispatch) => axios.post(`${Config.api.endpoint}api/Menu/new`, params, Config.getApiConfig()).then((res) => {
        if (res) {
            dispatch({
                type: 'MENU_POST_SUCCESS',
                payload: {
                    data: res.data,
                },
            });

            dispatch({
                type: 'MENU_REFRESH_TRUE',
            });

            dispatch(flashMessage('Menu created!', {
                timeout: 3000,
                props: {type: 'success'},
            }));

            return res;
        }
    }).catch((err) => {
        const errorObject = JSON.parse(JSON.stringify(err));
        console.log('ERROR', errorObject);
    });
}

export function patch(id, values) {
    const {title, ...newValues} = values;

    const menuData = [];

    Object.keys(values.menuData).forEach((language) => {
        const item = values.menuData[language];

        menuData.push(item);
    });

    const body = {
        ...newValues,
        menuData,
    };

    if (newValues.parentNodeId) {
        body.parentNodeId = newValues.parentNodeId;
    } else {
        body.parentWorkspaceId = 1;
    }

    return (dispatch) => axios.patch(`${Config.api.endpoint}api/Menu`, body, Config.getApiConfig())
        .then((res) => {
            dispatch({
                type: 'MENU_PATCH_SUCCESS',
                payload: {
                    data: res.data,
                },
            });

            dispatch(flashMessage('Menu updated!', {
                timeout: 3000,
                props: {type: 'success'},
            }));

            return res;
        }).catch((err) => {
            console.log(err);

            dispatch({
                type: 'MENU_PATCH_FAILED',
            });
        });
}

export function remove(id) {
    return (dispatch) => axios.delete(`${Config.api.endpoint}api/Menu/${id}`, Config.getApiConfig()).then((res) => res);
}

export function put(id, values) {
    return (dispatch) => axios.put(`${Config.api.endpoint}api/Content/structure/${id}/page`, values, Config.getApiConfig()).then((response) => {
        if (response) {
            dispatch(single(id));

            dispatch({
                type: 'MENU_PUT_SUCCESS',
                payload: {
                    data: response.data,
                },
            });

            dispatch({
                type: 'MENU_REFRESH_TRUE',
            });

            dispatch(flashMessage('Menu updated!', {
                timeout: 3000,
                props: {type: 'success'},
            }));

            return response;
        }
    });
}

export function destroy(id) {
    return (dispatch) => axios.delete(`${Config.api.endpoint}api/Content/structure/${id}/page`, Config.getApiConfig()).then((response) => {
        if (response) {
            dispatch({
                type: 'MENU_DESTROY_SUCCESS',
                payload: {
                    data: response.data,
                },
            });

            dispatch({
                type: 'MENU_REFRESH_TRUE',
            });

            dispatch(flashMessage('Menu deleted!', {
                timeout: 3000,
                props: {type: 'success'},
            }));

            return response;
        }
    });
}

export function refreshTrue() {
    return (dispatch) => {
        dispatch({
            type: 'MENU_REFRESH_TRUE',
        });

        return Promise.resolve(true);
    };
}

export function refreshFalse() {
    return (dispatch) => {
        dispatch({
            type: 'MENU_REFRESH_FALSE',
        });

        return Promise.resolve(true);
    };
}



// WEBPACK FOOTER //
// ./src/core/admin/store/actions/menu.js